import { createContext, useContext } from 'react';
export var ChainStateContext = createContext({
  multicallAddress: '',
  dispatchCalls: function dispatchCalls() {// empty
  }
});
export function useChainState() {
  return useContext(ChainStateContext);
}